<template>
  <el-dialog v-bind="$attrs" :title="title" v-model="modelValue" :draggable="draggable">
    <template #header><slot name="header"></slot></template>
    <div class="content" v-loading="props.loading">
      <slot></slot>
    </div>
    <template #footer v-if="footer">
      <span v-if="!slots.footer" class="dialog-footer">
        <slot name="fbutton"></slot>
        <el-button
          v-for="{ label, vOn, ...args } in options"
          :key="label"
          v-bind="args || {}"
          v-on="vOn || {}"
          >{{ label }}</el-button
        >
      </span>
      <slot v-else name="footer"></slot>
    </template>
  </el-dialog>
</template>
<script setup>
import {
  computed,
  ref,
  reactive,
  onBeforeMount,
  useAttrs,
  useSlots,
} from "vue";
import { useVModel } from "@vueuse/core";
import { ArrowDownBold, Search, Refresh } from "@element-plus/icons-vue";
const slots = useSlots();
const attrs = useAttrs();
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  order: {
    type: Array,
    default: () => ["cancel", "confirm"],
  },
  label: {
    // 当传入options时，label失效
    type: Array,
    default: () => [],
  },
  footer: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  modelValue: {},
  draggable: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(["update:modelValue"]);
const modelValue = useVModel(props, "modelValue", emit);

const options = computed(() => {
  const btn = ref([
    {
      label: "确认",
      type: "primary",
      id: "confirm",
      vOn: {
        click() {
          attrs.onConfirm?.();
        },
      },
    },
    {
      label: "取消",
      id: "cancel",
      vOn: {
        click() {
          attrs.onCancel?.();
          modelValue.value = false;
        },
      },
    },
  ]);
  // 过滤出隐藏的按钮后，对按钮按照传入的order进行排序
  console.log(attrs.options, "attrs.options");
  const sortArr = (attrs.options || btn.value)
    .filter((item) => props.order.includes(item.id))
    .sort((a, b) => props.order.indexOf(a.id) - props.order.indexOf(b.id));
  // 按照label顺序给按钮赋值名称
  attrs.options ||
    sortArr.forEach((item, index) => {
      if (props.label[index]) {
        item.label = props.label[index];
      }
    });
  return sortArr;
});
</script>
